import * as React from "react";

type Props = {
    company: string;
    ytunnus: string;
    customerRepresentative: string;

    customertitle: string;
    customertext: string;
};

type State = {

};

export default class CustomerPanel extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
    };

    public render() {
        return (
            <section className="customer-panel col-md-4">
                <div className="customer-panel-inner">
                    <h5>{this.props.customertitle}</h5>
                    <br />
                    <p>{this.props.company}</p>
                    <p>{this.props.ytunnus}</p>
                    <br/>
                    <p dangerouslySetInnerHTML={{ __html: this.props.customertext }}></p>
                    
                </div>
            </section>
            );
    };
}